export const enum RouteName {
  Home = "home",
  Index = "index",
  Detail = "detail",
  About = "about"
}
